import axios from "axios";

const actions = {
  getPersonioSettings(context) {
    return axios
      .get("personio/settings")
      .then((r) => r.data)
      .catch((e) => {
        context.dispatch("triggerError", e);
        return null;
      });
  },

  savePersonioSettings(context, payload) {
    return axios
      .put("personio/settings", payload)
      .then((r) => r.data)
      .catch((e) => {
        context.dispatch("triggerError", e);
        return null;
      });
  },

  deletePersonioSettings(context) {
    return axios
      .delete("personio/settings")
      .then((r) => r.data)
      .catch((e) => {
        context.dispatch("triggerError", e);
        return null;
      });
  },

  triggerPersonioSync(context) {
    return axios
      .post("personio/sync")
      .then((r) => r.data)
      .catch((e) => {
        context.dispatch("triggerError", e);
        return null;
      });
  },
};

export default actions;
